import React from 'react';
import LeaveButton from '../common/LeaveRace';
import TermsAndConditions from './TermsAndConditions';
import style from './index.scss';
import { Button } from 'js/components/main/LeaderboardButton/Button';
import { useTranslations } from '../../../../hooks/i18n';
import { useDeviceSelector } from '../../../../store/hooks';
import { pick } from 'ramda';
import { usePortletTranslations } from '../../../system/Portlet';
import classNames from './classNames';
import { statuses } from '../constants';

export const Fragment = ({ children }) => <>{children}</>;
export const Div = props => <div {...props} />;

export default (props) => {
    const { termsAndConditionsUrl, className = '', toShowPrizes, activeTab } = props;
    const Container = className ? Div : Fragment;
    const t = useTranslations();
    const t2 = usePortletTranslations();
    const { isMobile, isPortrait } = useDeviceSelector(pick(['isMobile', 'isPortrait']));
    return (
        <Container className={className}>
            <div className={style.footer}>
                <div className={style.termsAndConditionsBlock}>
                    <TermsAndConditions className={style.termsAndConditions} termsAndConditionsUrl={termsAndConditionsUrl}
                                        text={t('playtech.mobile.system.casino-leaderboard.termsAndConditions')}/>
                </div>
                <div className={classNames(style.buttonBlock, { [style.buttonsInColumn]: isMobile && isPortrait })}>
                    {(activeTab === 0 || toShowPrizes && activeTab === 1) && <Button
                        view='secondary'
                        variant='rounded'
                        color='lbHowToPlay'
                        size='large'
                        onClick={props.onHowToPlayCallback}
                        disabled={false}
                        className={style.howToPlay}>
                        {t2('howToPlay')}
                    </Button>}
                    {props.status !== statuses.COMPLETED && props.status !== statuses.PENDING_REVIEW &&
                        props.status !== statuses.CANCELLED && props.joined
                    && <LeaveButton {...props} />}
                </div>
            </div>
        </Container>
    );
};
